import { cn } from "@/utils/css";
import { RateBoundsLabels } from "./RateBoundsLabels";

export const RateRangeBar = ({
    leftLabel,
    rightLabel,
    minValue,
    maxValue,
    markerValue = null,
    reversed = false,
    markerColorClass = "bg-cm-p-text-primary",
    emptyDash = false,
}) => {
    // Allow a reverted axis (minValue > maxValue) so the "Start at"/"Leave at" values can be swapped by role.
    const hasRange = minValue != null && maxValue != null && minValue !== maxValue;
    if (!hasRange && !emptyDash) return null;

    // Works in both directions: with a reverted axis (maxValue - minValue) is negative and the fraction still
    // resolves to the correct position from the left.
    const markerPercent =
        hasRange && markerValue != null
            ? Math.min(100, Math.max(0, ((markerValue - minValue) / (maxValue - minValue)) * 100))
            : null;

    return (
        <div className="flex flex-col gap-2 w-full">
            <RateBoundsLabels
                leftLabel={leftLabel}
                rightLabel={rightLabel}
                minValue={minValue}
                maxValue={maxValue}
                emptyDash={emptyDash}
            />
            <div className="relative flex h-2 w-full items-center">
                <div
                    className={cn(
                        "h-1 w-full rounded-[40px] bg-gradient-to-r",
                        reversed
                            ? "from-cm-p-accent-500 via-cm-p-on-container-orange to-cm-p-on-container-red"
                            : "from-cm-p-on-container-red via-cm-p-on-container-orange to-cm-p-accent-600",
                    )}
                />
                {markerPercent != null ? (
                    <div
                        className={cn(
                            "absolute box-content h-1.5 w-[3px] -translate-x-1/2 rounded-[1px] border-2 border-cm-p-background",
                            markerColorClass,
                        )}
                        style={{ left: `${markerPercent}%` }}
                    />
                ) : null}
            </div>
        </div>
    );
};